<template>
    <div>
        <MasterLayout>
            <div class="create_vouchers" >
                <div class="create_vouchers_right_section cus_bal" :style="[{backgroundImage: `linear-gradient(rgb(12, 4, 31 , 0.92), rgb(12, 4, 31 , 0.92)), url(${backgroundUrl})`,backgroundPosition:'center', backgroundRepeat: 'no-repeat', backgroundSize: 'cover'}]">
                    <div class="transaction_period_text text-center mt-3">
                        <img src="@/assets/img/Path 52.png" class="mt-3" />
                        <h5 class="create_new_voucher_btn mt-3">{{$t('text.createVoucher.createNew')}}</h5>
                        <p class="mt-3">{{$t('text.createVoucher.completeAtLeast')}}</p>
                    </div>
                </div>
            </div>
            <div class="section_2 mt-3">
                <div class="create_voucher_div">
                    <div class="first_row">
                        <div class="first_row_header ">
                            <div class="block_1 mt-3 text-center">
                                <h5>{{$t('text.createVoucher.amount')}}</h5>
                            </div>
                            <div class="block_2 mt-3 text-center">
                                <h5>{{$t('text.createVoucher.byHowMany')}}</h5>
                            </div>
                            <div class="block_3 mt-3 text-center">
                                <h5>{{$t('text.createVoucher.returnBalanceTo')}}</h5>
                            </div>
                            <div class="block_4 mt-3 text-center">
                                <h5>{{$t('text.createVoucher.expiry')}}</h5>
                            </div>
                            <div class="block_5 mt-3 text-center">
                                <h5>{{$t('text.createVoucher.canBeUsedIn')}}</h5>
                            </div>
                            <div class="block_6 mt-3 text-center">
                            </div>
                        </div>
                    </div>

                    <div class="input__section_row">
                        <div class="vouchers_form_row" v-for="(vouchersArray,index) in vouchersArray"  :key="index">
                            <div class="block_1">
                                <div class="form_input_section mt-5">
                                    <!-- <div class="input__div mr-2" ref="amount_input_div ">
                                        <div class="small_placeholder_div_theme_bg" style="flex: 0 0 22%; height: 50px"> 
                                            <img src="@/assets/img/user (1).png" width="25px" class="input_placeholder_icon" />
                                        </div>
                                        <div class="input_field_section">
                                            <input class="mr-2" type="number"  placeholder="Amount"  @input="captureFormEvents($event)" v-model="vouchersArray.amount"/>
                                        </div>
                                    </div> -->
                                     <div class="input__block " ref="amount_input_div">
                                        <input
                                            type="number"
                                            :placeholder="$t('text.createVoucher.amount')"
                                            class="form-control input_full_width "
                                            @blur="captureFormEvents($event)"
                                            v-model="vouchersArray.amount"
                                        />
                                    </div>
                                    <div ref="amount_error_template"></div>
                                </div>
                            </div>
                            <div class="block_2">
                                <div class="form_input_section mt-5">
                                    <!-- <div class="input__div mr-2" ref="by_how_many_input_div">
                                        <div class="small_placeholder_div_theme_bg" style="flex: 0 0 22%; height: 50px"> 
                                            <img src="@/assets/img/user (1).png" width="25px" class="input_placeholder_icon" />
                                        </div>
                                        <div class="input_field_section">
                                            <input type="number"  placeholder="By How Many"  @input="captureFormEvents($event)" v-model="vouchersArray.numberOfPin"/>
                                        </div>
                                    </div> -->
                                     <div class="input__block " ref="balance_to_input_div">
                                        <input
                                            type="number"
                                            :placeholder="$t('text.createVoucher.byHowMany')"
                                            class="form-control input_full_width"
                                            @blur="captureFormEvents($event)"
                                            v-model="vouchersArray.numberOfPin"
                                        />
                                    </div>
                                    <div ref="by_how_many_error_template"></div>
                                </div>
                            </div>
                            <div class="block_3">
                                <div class="form_input_section mt-5">
                                    <!-- <div class="input__div mr-2" ref="balance_to_input_div">
                                        <div class="small_placeholder_div_theme_bg" style="flex: 0 0 22%; height: 50px"> 
                                            <img src="@/assets/img/user (1).png" width="25px" class="input_placeholder_icon" />
                                        </div>
                                        <div class="input_field_section mr-2">
                                             <select v-model="vouchersArray.returnBalanceTo">
                                                <option value="bearer">Bearer</option>
                                                <option value="wallet">Wallet</option>
                                            </select>
                                        </div>
                                    </div> -->
                                    <div class="input__block " ref="balance_to_input_div">
                                        <select v-model="vouchersArray.returnBalanceTo">
                                            <option value="bearer">{{$t('text.createVoucher.bearer')}}</option>
                                            <option value="wallet">{{$t('text.createVoucher.wallet')}}</option>
                                        </select>
                                    </div>
                                    <div ref="balance_to_error_template"></div>
                                </div>
                            </div>
                            <div class="block_4">
                                <div class="form_input_section mt-5">
                                    <!-- <div class="input__div mr-2" ref="amount_input_div">
                                        <div class="small_placeholder_div_theme_bg" style="flex: 0 0 22%; height: 50px"> 
                                            <img src="@/assets/img/user (1).png" width="25px" class="input_placeholder_icon" />
                                        </div>
                                        <div class="input_field_section">
                                             <select v-model="vouchersArray.validity">
                                                <option value="Never">Never</option>
                                                <option value="0.25">6 hours</option>
                                                <option value="0.5">12 hours</option>
                                                <option value="1">24 hours</option>
                                                <option value="7">7 days</option>
                                                <option value="30">30 days</option>
                                            </select>
                                        </div>
                                        
                                    </div> -->
                                     <div class="input__block " ref="balance_to_input_div">
                                        <select v-model="vouchersArray.validity">
                                            <option value="Never">{{$t('text.createVoucher.never')}}</option>
                                            <option value="0.25">{{$t('text.createVoucher.sixHours')}}</option>
                                            <option value="0.5">{{$t('text.createVoucher.twelveHours')}}</option>
                                            <option value="1">{{$t('text.createVoucher.twentyFourHours')}}</option>
                                            <option value="7">{{$t('text.createVoucher.sevenDays')}}</option>
                                            <option value="30">{{$t('text.createVoucher.thirtyDays')}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                              <div class="block_5">
                                <div class="form_input_section mt-5">
                                    <!-- <div class="input__div mr-2" ref="amount_input_div">
                                        <div class="small_placeholder_div_theme_bg" style="flex: 0 0 22%; height: 50px"> 
                                            <img src="@/assets/img/user (1).png" width="25px" class="input_placeholder_icon" />
                                        </div>
                                        <div class="input_field_section">
                                             <select v-model="vouchersArray.canBeUsedIn" v-if="retainerships">
                                                 <option disabled>Can Be Used In</option>
                                                 <option >All</option>
                                                 <option  v-for="(retainership , index) in retainerships" :value="retainership.companyId" :key="index">{{retainership.company}}</option>
                                            </select>
                                            <select v-model="vouchersArray.canBeUsedIn" v-if="!retainerships">
                                                <option disabled>Can Be Used In</option>
                                                <option >All</option>
                                            </select>
                                        </div>
                                    </div> -->
                                    <div class="input__block " ref="balance_to_input_div">
                                        <select v-model="vouchersArray.canBeUsedIn" v-if="retainerships">
                                            <option disabled>{{$t('text.createVoucher.canBeUsedIn')}}</option>
                                            <option >{{$t('text.createVoucher.all')}}</option>
                                            <option  v-for="(retainership , index) in retainerships" :value="retainership.companyId" :key="index">{{retainership.company}}</option>
                                        </select>
                                        <select v-model="vouchersArray.canBeUsedIn" v-if="!retainerships">
                                            <option disabled>{{$t('text.createVoucher.canBeUsedIn')}}</option>
                                            <option >{{$t('text.createVoucher.all')}}</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                             <div class="block_6">
                                <img src="@/assets/img/remove (1).png" style="float: right; cursor: pointer" v-if="index > 0" @click="filterVoucherRowArray(index)"/>
                            </div>
                            
                        </div>
                        <div class="mt-3 pb-3">
                            <button class="save__btn record_expense_btn" @click="addVoucherRow">{{$t('text.createVoucher.addMore')}}</button>
                        </div>
                    </div>
                </div>
                <div class="text-center mt-4 mb-3">
                    <p class="service_charge_text">{{$t('text.createVoucher.serviceCharge', { currency: `${countryProducts.currency}` })}}{{charge}}</p>
                    <button class="save__btn record_expense_btn other_btn_4" 
                            @click="createVoucher($event)"
                            :disabled="isButtonDisabled ? true : null"
                            style="border: 0;"
                            :style= "[isButtonDisabled ? {cursor: 'not-allowed'} : {cursor: 'pointer'}]">{{$t('text.createVoucher.title')}}</button>
                    <img src="@/assets/img/git_loader.gif" style="display:none" width="35px" class="ml-3 loader" />
                </div>
            </div>
            
        </MasterLayout>
    </div>
</template>
<script>
    import MasterLayout from "@/views/Customer/MasterLayout.vue";
    import backgroundUrl from '@/assets/img/online-money-transfer-isometric-wallets-with-coins_107791-121.jpg'; 
    import configObject from "@/config";
    import countryProducts from "@/products";

    import JQuery from 'jquery';
    let $ = JQuery;

    export  default {
        title: "Create Vouchers:: Epump Portal",
        name: "DashboardHome",
        components: {
            MasterLayout,
        },
        data() {
            return {
                // countryProducts: localStorage.getItem('countryProducts') ? JSON.parse(localStorage.countryProducts) : countryProducts,
                charge: '20',
                backgroundUrl,
                toggleReturnBalanceToDropDown: false,
                returnBalanceTo: null,
                amount: null,
                byHowMany: null,
                toggleValidityDropdown: false,
                validity: null,
                validityValue: null,
                retainerships: null,
                vouchersArray: [
                    {
                        amount: 'null',
                        numberOfPin: 'null',
                        returnBalanceTo: 'wallet',
                        validity: 'Never',
                        canBeUsedIn: "All",

                    }
                ],
                showRetainership: false,
                isButtonDisabled: false,
              
            }
        },
        created() {
            this.getRetainership();
        },
        computed: {
            countryProducts: function () {
                return this.$store.getters.getCountryProducts
            }
        },
        methods: {
            toggleReturnBalanceToDropDownDisplay() {
                this.toggleReturnBalanceToDropDown = !this.toggleReturnBalanceToDropDown
            },
            addVoucherRow(){
                this.vouchersArray.push({
                    amount: 'null',
                    numberOfPin: 'null',
                    returnBalanceTo: 'wallet',
                    validity: 'Never',
                    canBeUsedIn: "All",
                })
            },
            getRetainership(){
                this.showLoader = true
                this.axios.get(`${configObject.apiBaseUrl}/Wallet/Retainerships`, configObject.authConfig())
                    .then(response => {
                        this.retainerships = response.data;
                        if(response.data.length > 0) {
                            this.showRetainership = true
                        }
                        this.showLoader = false;
                    }).catch (error => {
                    })
            },
            filterVoucherRowArray(index) {
                this.vouchersArray.splice(index, 1);
            },
             captureFormEvents($event){
                if($event.target.placeholder === this.$t('text.createVoucher.amount')){
                    if($event.target.value === ""){
                        this.$refs.amount_error_template.style.display = "block";
                        // this.$refs.amount_error_template.innerHTML = "Amount field cannot be blank";
                        this.$refs.amount_input_div.style.border = "1px solid red";
                        this.$refs.amount_error_template.style.color = "red";
                        this.formIsValid = false;
                    }else {
                        // this.$refs.amount_error_template.style.display = "none";
                        // this.$refs.amount_input_div.style.border = "1px solid white";
                        this.formIsValid = true;
                    }
                }

                if($event.target.placeholder === this.$t('text.createVoucher.byHowMany')){
                    if($event.target.value === ""){
                        this.$refs.by_how_many_error_template.style.display = "block";
                        // this.$refs.by_how_many_error_template.innerHTML = "Field cannot be blank";
                        this.$refs.by_how_many_input_div.style.border = "1px solid red";
                        this.$refs.by_how_many_error_template.style.color = "red";
                        this.formIsValid = false;
                    }else {
                        // this.$refs.by_how_many_error_template.style.display = "none";
                        // this.$refs.by_how_many_input_div.style.border = "1px solid rgb(75, 44, 114)";
                        this.formIsValid = true;
                    }
                }
            },
            getReturnBalanaceToDropdownItem(returnBalanceToDropdownItem) {
                this.returnBalanceTo = returnBalanceToDropdownItem;
                this.toggleReturnBalanceToDropDown = !this.toggleReturnBalanceToDropDown;
                $(".balance_to_input").css('color' , '#6a7dcb12;');
                $(".balance_to_input").val(returnBalanceToDropdownItem);
            },
             toggleValidityDropDownDisplay() {
                    this.toggleValidityDropdown = !this.toggleValidityDropdown;
                    this.toggleReturnBalanceToDropDown = false;
            },
             getValidityItem(name, value) {
                this.validity = name;
                this.validityValue = value
                this.toggleValidityDropdown = !this.toggleValidityDropdown;
                $(".validity_input").css("color", "6a7dcb12");
                $(".validity_input").val(name);
            },
            changeRoute ($newRoute) {
                this.$router.push({name: $newRoute});
            },
             showFundWalletModal () {
                this.$modal.show('fund-wallet');
            },
            createVoucher ($event) {
                $event.preventDefault();
                let desc = ''
                let exit = false
                this.vouchersArray.forEach(voucherDetail => {
                    voucherDetail.amount = parseFloat(voucherDetail.amount);
                    voucherDetail.numberOfPin = parseInt(voucherDetail.numberOfPin);
                    if (!voucherDetail.numberOfPin) {
                        exit = true
                        desc = 'voucherEmpty'
                    }
                    if (voucherDetail.numberOfPin < 1) {
                        exit = true
                        desc = 'vouchers'
                    }
                    if (!voucherDetail.amount) {
                        exit = true
                        desc = 'amountEmpty'
                    }
                    if (voucherDetail.amount < 1) {
                        exit = true
                        desc = 'amount'
                    }
                })
                if (exit) {
                    this.$toast.open({
                        message: desc === 'amount' ? this.$t('text.createVoucher.amountInvalid') : desc === 'vouchers' ? this.$t('text.createVoucher.lowVouchers') : desc === 'amountEmpty' ? this.$t('text.createVoucher.amountMissing') : this.$t('text.createVoucher.vouchersNumberBlank'),
                        type: 'error',
                        duration: 5000
                    });
                    return
                }
                let data = this.vouchersArray;
                this.isButtonDisabled = true;
                $('.loader').show();
                this.axios.post(`${configObject.apiBaseUrl}/Voucher/CreateNewVoucher`, data, configObject.authConfig())
                    .then((res) => {
                        this.$toast.open({
                            message: this.$t('text.createVoucher.successfullyCreated'),
                            type: 'success',
                            duration: 3000
                        });
                        $('.loader').hide();
                        this.isButtonDisabled = false;
                        this.$router.push({name: "voucher"});
                    }).catch(error => {
                        this.$toast.open({
                            message: error.response.data.message ,
                            type: 'error',
                            duration: 5000
                        });  
                    $('.loader').hide(); 
                    this.isButtonDisabled = false; 
                });
            },
        }
    }
</script>

